/**
 * One-shot "you left <event>" flash for /join. Deliberately sessionStorage,
 * NOT a search param: a `?left=` URL would let anyone craft a link rendering
 * arbitrary text in our UI (content spoofing) — a foreign origin cannot write
 * our sessionStorage.
 */
const KEY = "ec2.leftEvent";

/** Maximum rendered length — defensive clamp even for our own writes. */
const MAX_NAME_LENGTH = 60;

export function storeLeftEvent(eventName: string): void {
  try {
    sessionStorage.setItem(KEY, eventName);
  } catch {
    /* storage unavailable → no flash, never an error */
  }
}

/** Read AND clear: the flash shows exactly once. */
export function takeLeftEvent(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value === null) return null;
    sessionStorage.removeItem(KEY);
    return value.slice(0, MAX_NAME_LENGTH);
  } catch {
    return null;
  }
}
